module.exports = __webpack_public_path__ + "media/carousel_images/Imagen1-918c4a68.png";